// extracted by mini-css-extract-plugin
module.exports = {"ecTagsButton":"Tags_ecTagsButton__kt6Yw","ecCondominiumTags":"Tags_ecCondominiumTags__Mux3y","showScale":"Tags_showScale__JutFe"};